// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d7d29e10","455":"eb2e6422","977":"ae8abc3c"}[chunkId] + ".chunk.js";
};